import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/auth.service';
import { UserTypes } from '../../shared/interfaces';

@Component({
  selector: 'app-recover',
  templateUrl: 'recover.component.html',
})
export class RecoverComponent implements OnInit {
  form: UntypedFormGroup;
  message: string;
  token: string;

  showRequirements = false;

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute,
    public toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      password: ['', [Validators.required, this.checkStrength.bind(this)]],
      repeatPassword: ['', [Validators.required, this.checkPasswords.bind(this)]],
      email: '',
    });

    this.form.controls.email.disable();

    this.form.get('password').valueChanges.subscribe(() => {
      this.form.controls.repeatPassword.updateValueAndValidity();
    });

    this.route.params.subscribe(async x => {
      this.token = x.token;

      const info = await this.authService.tokenInfo(this.token);

      if (info.error) {
        this.message = 'Invalid token';
        this.form.controls.password.disable();
        this.form.controls.repeatPassword.disable();
      }

      if (info.email) {
        this.form.controls.email.setValue(info.email);
      }
    });
  }

  checkStrength() {
    if (this.form && !this.authService.checkPasswordStrength(this.form.get('password').value)) {
      return { strenght: 'Not enough strength' };
    }
  }

  checkPasswords() {
    if (this.form && this.form.controls.password.value !== this.form.controls.repeatPassword.value) {
      return { repeat: "Doesn't match" };
    }
  }

  async submit() {
    this.message = '';

    try {
      const user = await this.authService.recover({
        token: this.token,
        newPassword: this.form.controls.password.value,
      });

      if (user.error) {
        this.showRequirements = true;
        this.message = `Passwords must follow the requirements below`;
      } else {
        this.message = '';
        this.showRequirements = false;
        if (user.type === UserTypes.INSPECTOR) {
          this.router.navigateByUrl('/download/gotoapp');
        } else {
          this.router.navigateByUrl('/login');
          this.toastr.success('Password set, now login.', null, { timeOut: 8000 });
        }
      }
    } catch (e) {
      this.message = 'Server error, try again later.';
    }
  }

  getValidationClass(field: string) {
    if (this.showRequirements) {
      return { 'is-invalid': true };
    }
    const control = this.form.controls[field];
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }

  passwordValidation() {
    const password = this.form && this.form.get('password').value;
    const number = /\d/.test(password);
    const symbol = /[!-\/:-@[-`{-~]/.test(password);
    const lower = password.toUpperCase() !== password;
    const upper = password.toLowerCase() !== password;
    const sum = (number ? 1 : 0) + (symbol ? 1 : 0) + (lower ? 1 : 0) + (upper ? 1 : 0) >= 3;
    const min = password.length >= 10;

    return { number, symbol, lower, upper, sum, min };
  }
}
